import Sortable from 'sortablejs'
import {
  activateItem,
  deactivateItem,
  clearItem,
  deactivateItems,
  findItemByVariant,
  findActive,
  findEmpty,
  fillSlot,
  activateSwatch,
  deactivateSwatch,
  resizeCompareImages,
  debounce,
  modalSwatches
} from './functions'

HTMLDocument.prototype.ready = function () {
  // Document load/ready promise, calls 'ready' method when completed
  return new Promise(function (resolve, reject) {
    if (document.readyState === 'complete') {
      resolve(document)
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        resolve(document)
      })
    }
  })
}

document.ready().then(function () {
  const modal = document.getElementById('compare-colors')
  const gridEl = document.getElementById('compare-grid')
  const modalButton = document.getElementById('compare-colors-button')
  // Client request
  const forcePerRowMobile = 7

  // On a Yarn or Patterns product page
  if (window.yarnVariants && modal && gridEl) {
    const swatches = modal.querySelectorAll('.swatch-circle')
    let items = gridEl.querySelectorAll('.CompareGrid__Item')
    const imageWrappers = gridEl.querySelectorAll('.CompareGrid__Image')
    const grid = []
    const colorsWrapper = document.querySelector('.colors-wrapper')
    let gridItems

    if (colorsWrapper) {
      gridItems = Array.from(colorsWrapper.children)

      modalSwatches(swatches, forcePerRowMobile)

      modalButton.addEventListener('click', function () {
        modalSwatches(swatches, forcePerRowMobile)
      })

      window.addEventListener(
        'resize.optimized',
        debounce(function () {
          modalSwatches(swatches, forcePerRowMobile)
        }, 300)
      )
    }

    Sortable.create(gridEl, {
      animation: 150,
      ghostClass: 'dragging'
    })

    for (const itemEl of items) {
      grid[itemEl.id] = {
        empty: true,
        active: false,
        itemEl,
        image: ``,
        text: ``,
        imageWrapper: itemEl.querySelector('.CompareGrid__Image'),
        textWrapper: itemEl.querySelector('.CompareGrid__Text'),
        variantID: null
      }

      const item = grid[itemEl.id]

      itemEl.addEventListener('click', function () {
        if (item.active === true) {
          deactivateItem(item)
        } else {
          deactivateItems(grid)
          activateItem(item)
        }

        resizeCompareImages(gridEl, imageWrappers)
      })
    }

    for (const swatch of swatches) {
      swatch.addEventListener('click', function () {
        // Deactivate color
        if (swatch.classList.contains('active')) {
          deactivateSwatch(swatch)

          const item = findItemByVariant(swatch.dataset.variant, grid)
          if (item) {
            clearItem(item)
          }
        }
        // Activate new color...
        else {
          const activeItem = findActive(grid)
          const emptyItem = findEmpty(grid)
          activateSwatch(swatch)

          // User clicked on a slot
          if (activeItem !== false) {
            // The active slot is empty
            if (activeItem.empty === true) {
              fillSlot(activeItem, swatch.dataset.variant)
            } else {
              // Deactivate previous swatch
              deactivateSwatch(activeItem.variantID, true)
              // Fill with new item/swatch
              fillSlot(activeItem, swatch.dataset.variant)
            }
          }
          // Empty slot is available
          else if (emptyItem !== false) {
            fillSlot(emptyItem, swatch.dataset.variant)
          }
          // No empty slots available, replace last item
          else {
            // Query again in case the elements have been reorded in the DOM
            items = gridEl.querySelectorAll('.CompareGrid__Item')

            let lastItem = items[items.length - 1]
            lastItem = grid[lastItem.id]
            deactivateSwatch(lastItem.variantID, true)
            fillSlot(lastItem, swatch.dataset.variant)
          }
        }

        resizeCompareImages(gridEl, imageWrappers)
      })
    }

    window.addEventListener(
      'resize.optimized',
      debounce(function () {
        resizeCompareImages(gridEl, imageWrappers)
      }, 250)
    )

    console.log(window.yarnVariants)
  }
})
